import { Box, Grid, Paper, styled } from '@mui/material';
import React from 'react'
import { Component } from 'react'
import CambioHorario from './CambioHorario';
import HorarioVariado from './HorarioVariado';


const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

class Horario extends Component {
    constructor(props){
        super(props);
        this.state = {
            seleccion: {
                tipoHorario: '',
                horarioSemanal: false,
                cambioHorario: false,
            }
        }
        this.manejarCambiosDatos = this.manejarCambiosDatos.bind(this);
    }
    render(){
        return (
            <>
                <h3>Horarios</h3>
                <Box className='formulario1' sx={{ flexGrow: 1}} >
                    <Grid container spacing={2} rowSpacing={1}>
                        <Grid item xs={4}>
                            <Item>HORARIO</Item>
                        </Grid>
                        <Grid item xs={4}>
                            <Item>
                                <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='mes'  value={this.state.seleccion.tipoHorario} onChange={this.manejarCambiosDatos}>
                                    <option value=''>HORARIO</option>
                                    <option key={1} value={1}>CAMBIO DE HORARIO</option>
                                    <option key={2} value={2}>HORARIO SEMANAL</option>
                                </select>
                            </Item>
                        </Grid>
                    </Grid>
                </Box>
                {this.state.seleccion.cambioHorario ? <CambioHorario/> : null}
                {this.state.seleccion.horarioSemanal ? <HorarioVariado/> : null}
            </>
        )//Final Return
    }//Final render

    manejarCambiosDatos(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const seleccionActualizado = state.seleccion;
            if(valor === '1'){
                seleccionActualizado['cambioHorario'] = true;
                seleccionActualizado['horarioSemanal'] = false;
            }else if (valor === '2'){
                seleccionActualizado['horarioSemanal'] = true;
                seleccionActualizado['cambioHorario'] = false;
            }
            seleccionActualizado[clave] = valor;
            return{
                seleccion: seleccionActualizado,
            }
        })
    }
}

export default Horario